// @flow
import { createAction } from 'redux-actions';
import { identity, noop } from 'lodash'

const payloadCreator = identity;
const metaCreator = (_, resolve = noop, reject = noop) => ({ resolve, reject });

export const createPromiseAction = (type: string) => createAction(type, payloadCreator, metaCreator);

export const bindPromiseAction = (dispatch: any, actionCreator: any): any => (payload: any) =>
  new Promise((resolve, reject) => dispatch( actionCreator(payload, resolve, reject) ) );


export class StdFormError extends Error {

}
